import React from 'react';
import { AiUserInnerOptions } from '../AiUserInnerOptions';
import { useParams } from 'react-router-dom';
import { useAiUser } from 'hooks/api/settings/useAiUser';
import { useErrorHandler } from 'exceptions/ErrorHandler';
import { MainContainer } from 'components/shared';
import { SettingLayout } from 'layouts/SettingLayout';
import { UpdateForm } from './UpdateForm';
import { useQuery } from 'react-query';
import { Box } from 'components/ui/Box';

export const UpdateAiUser: React.FC = () => {
  const { options } = AiUserInnerOptions();
  const { id } = useParams<{ id: string }>();
  const { getAiUser } = useAiUser();
  const { errorHandler } = useErrorHandler();

  const { data } = useQuery({
    queryKey: ['aiUsers', id],
    queryFn: () => getAiUser(id),
    enabled: !!id,
    onError: errorHandler,
  });
  return (
    <MainContainer>
      <SettingLayout options={options} page="ai-users">
        <Box>{data && <UpdateForm aiUser={data} />}</Box>
      </SettingLayout>
    </MainContainer>
  );
};
